// extracted by mini-css-extract-plugin
module.exports = {"background":"Background_background__1xmw_","image1":"Background_image1__BOus3","image2":"Background_image2__j3Zpz","image3":"Background_image3__GWVTX"};